import { render, staticRenderFns } from "./check-record.vue?vue&type=template&id=45b700cd&scoped=true"
import script from "./check-record.vue?vue&type=script&lang=js"
export * from "./check-record.vue?vue&type=script&lang=js"
import style0 from "./check-record.vue?vue&type=style&index=0&id=45b700cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b700cd",
  null
  
)

export default component.exports